"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeOptions = exports.breakpoints = exports.pxToRem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
require("@fontsource/epilogue/400.css");
require("@fontsource/epilogue/700.css");
var LinkBehavior = react_1.default.forwardRef(function (props, ref) {
    var href = props.href, other = __rest(props, ["href"]);
    // eslint-disable-next-line react/jsx-props-no-spreading
    return (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ ref: ref, to: href }, other));
});
var pxToRem = function (px) { return "".concat(px / 16, "rem"); };
exports.pxToRem = pxToRem;
exports.breakpoints = {
    iPadPro: 1366,
    desktop: 6000,
};
var palette = (0, styles_1.createTheme)().palette;
exports.themeOptions = {
    spacing: 6,
    custom: {
        Header: {
            height: {
                xs: '120px',
            },
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: exports.breakpoints.iPadPro,
            xl: exports.breakpoints.desktop,
        },
    },
    palette: {
        primary: {
            main: '#3F47E5',
            light: '#ebecfc',
            dark: '#FAFCFC',
        },
        secondary: {
            light: '#DBE3EC',
            main: '#fefefe',
            dark: '#f7f9fa',
            '100': '#9da8b3',
        },
        darkGrey: palette.augmentColor({
            color: {
                main: '#506173',
            },
        }),
        redWarning: palette.augmentColor({
            color: {
                main: '#FF002B',
                dark: '#d32f2f',
            },
        }),
        background: {
            default: '#ffffff',
        },
        text: {
            primary: '#041E39',
            secondary: '#506173',
        },
    },
    components: {
        MuiLink: {
            defaultProps: {
                component: LinkBehavior,
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: '#DBE3EC',
                    '&.Mui-disabled': {
                        color: 'transparent',
                    },
                    '&.MuiCheckbox-root': {
                        width: '15px',
                        height: '15px',
                    },
                    '& .MuiSvgIcon-root': {
                        fontSize: '20px',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: function (_a) {
                    var _b;
                    var ownerState = _a.ownerState;
                    return (__assign(__assign((_b = { borderRadius: '10px 10px 10px 10px', fontFamily: 'Epilogue', fontWeight: 'bold', fontSize: (0, exports.pxToRem)(11) }, _b["@media (min-width:".concat(exports.breakpoints.desktop, "px)")] = {
                        fontSize: (0, exports.pxToRem)(12),
                    }, _b.textTransform = 'none', _b.height = '36px', _b), (ownerState.variant === 'outlined' && {
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        '&:hover': {
                            borderStyle: 'solid',
                            borderWidth: '1px',
                        },
                    })), (ownerState.variant === 'contained' && {
                        color: 'white',
                        borderColor: '#3F47E5',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        '&:hover': {
                            color: '#3F47E5',
                            borderColor: '#3F47E5',
                            borderWidth: '1px',
                            borderStyle: 'solid',
                            backgroundColor: 'white',
                        },
                    })));
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: (_a = {
                        fontSize: (0, exports.pxToRem)(12)
                    },
                    _a["@media (min-width:".concat(exports.breakpoints.desktop, "px)")] = {
                        fontSize: (0, exports.pxToRem)(13),
                    },
                    _a),
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                endAdornment: {
                    right: '6px',
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: (_b = {
                        fontSize: (0, exports.pxToRem)(12)
                    },
                    _b["@media (min-width:".concat(exports.breakpoints.desktop, "px)")] = {
                        fontSize: (0, exports.pxToRem)(13),
                    },
                    _b),
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: (_c = {
                        fontSize: (0, exports.pxToRem)(8)
                    },
                    _c["@media (min-width:".concat(exports.breakpoints.desktop, "px)")] = {
                        fontSize: (0, exports.pxToRem)(9),
                    },
                    _c),
            },
        },
    },
    mixins: { toolbar: { transform: 'none' } },
    typography: {
        fontWeightBold: 'bold',
        fontSize: 16,
        fontFamily: 'Epilogue',
        h1: (_d = {
                fontSize: (0, exports.pxToRem)(21)
            },
            _d["@media (min-width:".concat(exports.breakpoints.desktop, "px)")] = {
                fontSize: (0, exports.pxToRem)(26),
            },
            _d.fontWeight = 700,
            _d.lineHeight = 1.1,
            _d),
        h2: (_e = {
                fontSize: (0, exports.pxToRem)(16)
            },
            _e["@media (min-width:".concat(exports.breakpoints.desktop, "px)")] = {
                fontSize: (0, exports.pxToRem)(20),
            },
            _e.fontWeight = 700,
            _e.lineHeight = 1.1,
            _e),
        h3: (_f = {
                textTransform: 'uppercase',
                transform: 'none',
                color: '#9da8b3',
                pl: 0.5,
                position: 'relative',
                lineHeight: '1.66',
                fontSize: (0, exports.pxToRem)(10)
            },
            _f["@media (min-width:".concat(exports.breakpoints.desktop, "px)")] = {
                fontSize: (0, exports.pxToRem)(11),
            },
            _f),
        h4: (_g = {
                fontSize: (0, exports.pxToRem)(13)
            },
            _g["@media (min-width:".concat(exports.breakpoints.desktop, "px)")] = {
                fontSize: (0, exports.pxToRem)(16),
            },
            _g.fontWeight = 700,
            _g.lineHeight = 1,
            _g),
        body1: (_h = {
                fontSize: (0, exports.pxToRem)(13)
            },
            _h["@media (min-width:".concat(exports.breakpoints.desktop, "px)")] = {
                fontSize: (0, exports.pxToRem)(15),
            },
            _h.lineHeight = 1.5,
            _h.letterSpacing = '0px',
            _h),
        body2: (_j = {
                fontSize: (0, exports.pxToRem)(12)
            },
            _j["@media (min-width:".concat(exports.breakpoints.desktop, "px)")] = {
                fontSize: (0, exports.pxToRem)(13),
            },
            _j.lineHeight = 1.5,
            _j.marginBottom = 2,
            _j),
        caption: (_k = {
                lineHeight: 1.66,
                fontSize: (0, exports.pxToRem)(8)
            },
            _k["@media (min-width:".concat(exports.breakpoints.desktop, "px)")] = {
                fontSize: (0, exports.pxToRem)(9),
            },
            _k.textTransform = 'uppercase',
            _k.transform = 'none',
            _k.color = '#9da8b3',
            _k.pl = 0.5,
            _k['&:not(.Mui-error).Mui-focused'] = {
                color: '#9ea3f2',
            },
            _k),
    },
};
var theme = (0, styles_1.createTheme)(exports.themeOptions, {
    custom: {
        Header: {
            height: { xs: '120px' },
        },
    },
});
exports.default = theme;
//# sourceMappingURL=theme.js.map